<template>
  <v-app>
    <leftmenu></leftmenu>
    <topmenu></topmenu>
    <v-content style="" fill-height id="base-content">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
  import {mapState} from 'vuex'
  import Leftmenu from "./modules/menus/LeftMenu";
  import Topmenu from "./modules/menus/TopMenu";
  import {isAliveToken, isWorker, getInstMenu} from "./helper";

  export default {
    components: {Topmenu, Leftmenu},
    data() {
      return {
        clipped: true,
        drawer: true,
        surls: {},
      }
    },
    computed: mapState({
      leftmenu: state => state.leftmenu,
      maintoolbar: state => state.maintoolbar,
      user: state => state.user,
      urls: state => state.urls,
    }),
    watch: {
      urls() {
        this.surls = this.urls.urls
      }
    },
    methods: {},
    created: async function() {
      // console.log('Here i want wait my fucking promise');
        isAliveToken();
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    /*color: #2cc30e50;*/
    /*height: 100%;*/
  }
</style>
